import { __awaiter } from "tslib";
import { shareUrl, copyText } from '@/utils';
import { alas, status } from '@/alas';
import { showError, showSuccess } from '@/store';
import { defineComponent, reactive, onMounted, computed, ref } from '@vue/composition-api';
export default defineComponent({
    setup(prop, context) {
        let t = m => context.root.$t(m);
        let route = context.root.$route;
        let swiper = ref(null);
        // ================
        //
        // ref
        //
        let farm = ref(status.fetch('farm'));
        let types = ref(status.fetch('types'));
        // ================
        //
        // computed
        //
        let loading = computed(() => $.pictures.o.fetchArchived.loading);
        let images = computed(() => $.pictures.items.map(item => {
            let type = types.value.fetch(item.type);
            let events = item.$m.getEventsDetail(type);
            let tags = type.tags.items.filter(tag => item.tags.includes(tag.key)).map(e => {
                return {
                    text: e.name,
                    color: e.color
                };
            });
            return {
                text: item.$v.createdAt,
                image: item.$v.imageSrcMini,
                infoCount: events.filter(e => e.type.type === 'message' && e.type.key === 'message').length,
                imageCount: events.filter(e => e.type.type === 'message' && e.type.key === 'image').length,
                tags,
                events: events.filter(e => e.type.type !== 'message').map(e => {
                    return {
                        text: e.type.name,
                        color: e.type.color
                    };
                })
            };
        }));
        let swiperOption = computed(() => {
            return {
                lazy: true,
                centeredSlides: true,
                slidesPerView: $.viewPictureMode ? 1.5 : 1
            };
        });
        // ================
        //
        // state
        //
        let $ = reactive({
            index: 0,
            selectDialog: false,
            pictures: alas.makeList('farm', 'picture'),
            viewPictureMode: false,
            viewMessageBoard: false
        });
        // ================
        //
        // mounted
        //
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            let { date } = route.query;
            let { id, cycle } = route.params;
            try {
                yield $.pictures.o.fetchArchived.start({
                    farmId: id,
                    startTime: Number(cycle)
                });
                if (date) {
                    select($.pictures.items.findIndex(item => item.$v.createdAt === date));
                }
                else {
                    select(0);
                }
            }
            catch (error) {
                showError(error);
            }
        }));
        // ================
        //
        // methods
        //
        let slide = (index) => {
            select(swiper.value.$swiper.activeIndex);
        };
        let next = () => {
            if ($.index + 1 < $.pictures.size) {
                select($.index + 1);
            }
        };
        let prev = () => {
            if ($.index - 1 >= 0) {
                select($.index - 1);
            }
        };
        let select = (index) => {
            if (index <= 0) {
                index = 0;
            }
            $.index = index;
            if (swiper.value && swiper.value.$swiper.activeIndex !== index) {
                swiper.value.$swiper.slideTo($.index, 500);
            }
        };
        let share = () => __awaiter(this, void 0, void 0, function* () {
            let picture = $.pictures.items[$.index];
            let result = yield shareUrl('農業日誌', farm.value.name, location.href + `?date=${picture.$v.createdAt}`);
            if (result === false) {
                showError(t('本裝置不支援分享功能'));
            }
            else {
                showSuccess(t('分享成功'));
            }
        });
        let copyLink = () => {
            let picture = $.pictures.items[$.index];
            copyText(location.href + `?date=${picture.$v.createdAt}`);
            showSuccess(t('成功複製到剪貼簿'));
        };
        let inViewRange = (picture, index) => {
            if (picture.$self.loaded === true) {
                return true;
            }
            if (index === $.index || index === $.index - 1 || index === $.index + 1) {
                picture.$self.loaded = true;
                return true;
            }
            return false;
        };
        return {
            $,
            farm,
            next,
            prev,
            images,
            slide,
            swiper,
            select,
            loading,
            copyLink,
            share,
            inViewRange,
            swiperOption
        };
    }
});
